import Vue from "vue";
import Vuex from "vuex";

import i18n from "./i18n";
import search from "./search";
import toc from "./toc";
import transcript from "./transcript";
import translation from "./translation";
const createPersistedState = require("vuex-persistedstate").default;

Vue.use(Vuex);

const modules = { i18n, search, toc, transcript, translation };

const store = new Vuex.Store({
    modules,
    plugins: [createPersistedState({
        paths: [
            "i18n.locale",
            "i18n.localeSetByBrowserPreference",
            "transcript.watchlist"
        ]
    })]
});

export default store;